const data = {
    coatingType: ["Lamination", "Offset+Coater", "Leafing", "Spot UV", "Varnish", "Embossing"]
}

export default data